import AddIcon from '@mui/icons-material/Add';
import { Card, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { WsButton, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { WsBreadCrumbs } from '../../../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../../features/teams/helper/defaultValues';
import { AutomationChildRoutes } from '../../childRoutes';

export const AutomationFlowLayout = () => {
  const navigate = useNavigate();

  const handleAddNavigation = () => navigate(`/automation/add-new-automation`);

  return (
    <Grid sx={{ mx: 1, width: '90%' }}>
      <WsBreadCrumbs
        breadCrumbsList={getSettingBreadCrumbList(
          ISettingBreadCrumbTypes.AUTOMATION,
          Pages['AUTOMATION']
        )}
      />

      <Card sx={{ my: 1, p: 1.5 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <WsTypography variant={WsTypoVariants.TITLE} bold>
              Automations
            </WsTypography>
            <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.GREYTEXT}>
              Manage automations at various level
            </WsTypography>
          </Grid>

          <Grid item>
            <WsButton startIcon={<AddIcon />} variant="contained" onClick={handleAddNavigation}>
              Add Automation
            </WsButton>
          </Grid>
        </Grid>
      </Card>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AutomationChildRoutes />
        </Grid>
      </Grid>
    </Grid>
  );
};
